import * as decodeJWT from "jwt-decode";
import { makeActionCreator } from "../../store/types";
import { LoginToken } from "./reducer";

export const SAVE_TOKEN = "auth/SAVE_TOKEN";

const setToken = makeActionCreator<{
  token: string;
  tokenPayload?: LoginToken;
}>(SAVE_TOKEN as typeof SAVE_TOKEN);

export const saveToken = (token: string) => {
  let tokenPayload: LoginToken | undefined;

  try {
    tokenPayload = decodeJWT<LoginToken>(token);
  } catch (error) {
    // TODO: some stateful error handling...
  }

  return setToken({ token, tokenPayload });
};



// WEBPACK FOOTER //
// ./src/routes/Auth/actions.ts